<div mat-dialog-title>
  @if (data?.header) {
    <div class="title-content">
      <span>{{data.header?.title}}</span>
      <span class="sub-title">{{data.header?.subtitle}}</span>
    </div>
  }

  <button [mat-dialog-close]="null">
    <i class="fa fa-times"></i>
  </button>
</div>

<mat-dialog-content>

  @if (data?.dafSummary) {
    <div class="custom-content form-container">
      <app-dropdown [options]="data.dafSummary?.options ?? []"
                    [fieldPlaceholder]="data.dafSummary?.label ?? ''"
                    [valueFormControl]="dafTypeFormControl"
      ></app-dropdown>

      @if (dafTypeFormControl.invalid && dafTypeFormControl.touched) {
        <span class="error-message">{{'error.empty-field' | translate}}</span>
      }
    </div>
  }

  <p-fileUpload
        (uploadHandler)="onUploadHandler($event)"
        [accept]="allowedExtensions"
        [customUpload]="true"
        [previewWidth]="0"
        [showCancelButton]="true"
        [maxFileSize]="maxFileSize"
        [mode]="'advanced'"
        [chooseLabel]="'component.uploadFile.choseFile' | translate"
        [uploadLabel]="'component.uploadFile.uploadFile' | translate"
        [cancelLabel]="'component.uploadFile.concelFile' | translate"
        [invalidFileTypeMessageDetail]="'component.uploadFile.invalidFileTypeMessage' | translate"
    >
      <ng-template #empty>
        <span class="empty-template">{{'component.uploadFile.emptyMessage' | translate}}</span>
      </ng-template>
    </p-fileUpload>
</mat-dialog-content>
